import { Navigate, useLocation } from "react-router";
import { useActiveTeam } from "~/hooks/useTeamAccess";
import { teamSlug } from "~/lib/team-path";

export default function LegacyTeamRedirect() {
  const activeTeam = useActiveTeam();
  const { pathname, search, hash } = useLocation();

  if (!activeTeam) {
    return <Navigate to="/" replace />;
  }

  return (
    <Navigate
      to={`/t/${teamSlug(activeTeam)}${pathname}${search}${hash}`}
      replace
    />
  );
}
